import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  const selectedIndex = this.attr("breadcrumbs").findIndex(node => !!node.selected);
  const breadcrumbs = this.attr("breadcrumbs").map((node, i) => {
    return jsx(null, null, jsx("div", {
      sel: '.breadcrumb-node.mp-font-weight-medium',
      on: {
        click: () => this.helpers.handleNodeClicked(node)
      },
      class: {
        'node-link': i < selectedIndex,
        disabled: i > selectedIndex,
        selected: node.selected
      }
    }, jsx("div", {
      sel: '.node-index'
    }, i + 1), jsx("div", {
      sel: '.node-label'
    }, node.label)), i < this.attr("breadcrumbs").length - 1 && jsx(SvgIconEl, {
      sel: '.caret',
      attrs: {
        icon: "caret-right"
      }
    }));
  });
  return jsx("div", {
    sel: '.breadcrumbs'
  }, breadcrumbs);
}